import React from 'react';
import { Outlet, Link } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';

function Navbar() {
    return (
        <>
            <nav className='navbar navbar-expand-lg navbar-light bg-warning '>
                <ul className='d-flex '>
                    <li>
                        <Link to="/" className='m-5'>Home</Link>
                    </li>
                    <li>
                        <Link to="/contract" className='m-5'>Contact</Link>
                    </li>   
                    <li>
                        <Link to="/contract" className='m-5'>Contact</Link>
                    </li>                   
                </ul>
            </nav>

            <Outlet />
        </>
    )
}

export default Navbar